const HisAI = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg style={_sx} viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.7731 4.23438H4.61799C4.15158 4.23438 3.70427 4.41966 3.37446 4.74946C3.04466 5.07927 2.85938 5.52658 2.85938 5.99299V18.3033C2.85938 18.7697 3.04466 19.217 3.37446 19.5468C3.70427 19.8766 4.15158 20.0619 4.61799 20.0619H16.9283C17.3947 20.0619 17.842 19.8766 18.1718 19.5468C18.5016 19.217 18.6869 18.7697 18.6869 18.3033V12.1481"
        stroke={strokeColor}
        strokeWidth="1.75862"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7211 3.59375L15.1321 5.25878C15.4223 6.43418 16.3401 7.35193 17.5155 7.6421L19.1805 8.05314L17.5155 8.46418C16.3401 8.75435 15.4223 9.67209 15.1321 10.8475L14.7211 12.5125L14.3101 10.8475C14.0199 9.67209 13.1022 8.75435 11.9267 8.46418L10.2617 8.05314L11.9267 7.6421C13.1022 7.35193 14.0199 6.43419 14.3101 5.25878L14.7211 3.59375Z"
        fill={strokeColor}
      />
      <path
        d="M18.0639 2.41406L18.2322 3.09572C18.351 3.57692 18.7267 3.95264 19.2079 4.07143L19.8896 4.23971L19.2079 4.40799C18.7267 4.52678 18.351 4.9025 18.2322 5.38371L18.0639 6.06536L17.8957 5.38371C17.7769 4.9025 17.4011 4.52678 16.9199 4.40799L16.2383 4.23971L16.9199 4.07143C17.4011 3.95264 17.7769 3.57692 17.8957 3.09572L18.0639 2.41406Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export default HisAI;
